import { Button, Grid, MenuItem, TextField } from "@mui/material";
import InputMask from "react-input-mask";
import styles from "./styles.module.css";
import { useEffect, useState } from "react";
import { validarFormatacaoDocumento } from "../../../services/validation.service";
import BtnImportarDados from "../BtnImportarDados";

const DadosProcurador = ({
  handleStep,
  dataForm,
  setDataForm,
  setMsg,
  setOpenSnackbarErro,
  error,
  setError,
  handleError,
  handleHelperText,
}) => {
  const [mascaraDocumento, setMascaraDocumento] =
    useState("99.999.999/9999-99");
  const [valid, setValid] = useState({
    documento: true,
    cpf: false,
  });

  const tiposDocumento = ["CNPJ", "RG", "RNE"];

  const handleVerificarDocumento = async (value, type) => {
    const response = await validarFormatacaoDocumento(value, type);

    switch (type) {
      case "CNPJ":
        if (!response) {
          setValid({
            ...valid,
            documento: false,
          });
          setMsg("CNPJ inválido!");
          setOpenSnackbarErro(true);
        } else {
          setValid({
            ...valid,
            documento: true,
          });
        }
        break;
      case "CPF":
        if (!response) {
          setValid({
            ...valid,
            cpf: false,
          });
          setMsg("CPF inválido!");
          setOpenSnackbarErro(true);
        } else {
          setValid({
            ...valid,
            cpf: true,
          });
        }
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    setError(false);
  }, []);

  useEffect(() => {
    switch (dataForm?.dadosProcurador?.tipoDocumento) {
      case "RG":
        {
          setMascaraDocumento("********************");
          setValid({
            ...valid,
            documento: true,
          });
        }
        break;
      case "CNPJ":
        {
          setMascaraDocumento("99.999.999/9999-99");
          setValid({
            ...valid,
            documento: true,
          });
        }
        break;
      case "RNE":
        {
          setMascaraDocumento("a9999999-a");
          setValid({
            ...valid,
            documento: true,
          });
        }
        break;

      default:
        break;
    }
  }, [dataForm?.dadosProcurador?.tipoDocumento]);

  useEffect(() => {
    const cnpj = dataForm?.dadosProcurador?.documento;
    const cpf = dataForm?.dadosProcurador?.cpf;

    if (dataForm?.dadosProcurador?.tipoDocumento === "CNPJ") {
      if (cnpj?.length === 14) {
        handleVerificarDocumento(cnpj, "CNPJ");
      } else {
        setValid({
          ...valid,
          documento: false,
        });
      }
    } else {
      setValid({
        ...valid,
        documento: true,
      });
    }
    if (cpf?.length === 11) {
      handleVerificarDocumento(cpf, "CPF");
    } else {
      setValid({
        ...valid,
        cpf: false,
      });
    }
  }, [dataForm?.dadosProcurador?.documento, dataForm?.dadosProcurador?.cpf]);

  const handleNext = (e) => {
    e.preventDefault();
    const form = e.target;

    if (dataForm?.dadosProcurador?.cpf && !valid.cpf) {
      setMsg("CPF Inválido");
      setOpenSnackbarErro(true);
    }

    if (form.checkValidity() && valid.cpf) {
      handleStep(5);
    } else {
      setError(true);
    }
  };

  const handleBack = () => {
    handleStep(3);
  };

  const handleChange = (e) => {
    const { name } = e.target;
    let value = e.target.value;

    switch (name) {
      case "documento":
        value = value.replace(/[^\w\s]/gi, "");
        break;
      case "cpf":
        value = value.replace(/[^\w\s]/gi, "");
        break;
    }

    setDataForm({
      ...dataForm,
      dadosProcurador: { ...dataForm.dadosProcurador, [name]: value },
    });
  };

  return (
    <form className={styles.form_container} onSubmit={handleNext} noValidate>
      <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
        <Grid item xs={12} sm={4} lg={2}>
          <BtnImportarDados
            step={5}
            dataForm={dataForm}
            setDataForm={setDataForm}
          />
        </Grid>
        <Grid item xs={12} sm={4} lg={5}>
          <TextField
            size="small"
            label="Nome"
            name="nome"
            fullWidth
            value={dataForm?.dadosProcurador?.nome || ""}
            onChange={handleChange}
            error={handleError("dadosProcurador", "nome")}
            helperText={handleHelperText("dadosProcurador", "nome")}
            required
          />
        </Grid>
        <Grid item xs={12} sm={4} lg={5}>
          <TextField
            size="small"
            label="E-mail"
            name="email"
            fullWidth
            value={dataForm?.dadosProcurador?.email || ""}
            error={handleError("dadosProcurador", "email")}
            helperText={handleHelperText("dadosProcurador", "email")}
            onChange={handleChange}
            required
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            size="small"
            label="Tipo Documento"
            name="tipoDocumento"
            fullWidth
            value={dataForm?.dadosProcurador?.tipoDocumento || "CNPJ"}
            onChange={handleChange}
            select
          >
            {tiposDocumento.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={3} md={3}>
          <InputMask
            mask={mascaraDocumento}
            maskChar={null}
            onChange={handleChange}
            value={dataForm?.dadosProcurador?.documento || ""}
          >
            {() => (
              <TextField
                size="small"
                label="Documento"
                name="documento"
                fullWidth
                error={
                  dataForm?.dadosProcurador?.tipoDocumento === "CNPJ" &&
                  !valid.documento
                    ? true
                    : handleError("dadosProcurador", "documento")
                }
                helperText={handleHelperText("dadosProcurador", "documento")}
                color={
                  dataForm?.dadosProcurador?.tipoDocumento === "CNPJ" &&
                  !valid.documento
                    ? "error"
                    : ""
                }
                required
              />
            )}
          </InputMask>
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputMask
            mask="999.999.999-99"
            maskChar={null}
            value={dataForm?.dadosProcurador?.cpf || ""}
            onChange={handleChange}
          >
            {() => (
              <TextField
                size="small"
                label="CPF"
                fullWidth
                name="cpf"
                error={error && (!valid.cpf || !dataForm?.dadosProcurador?.cpf)}
                helperText={handleHelperText("dadosProcurador", "cpf")}
                color={
                  valid.cpf && dataForm?.dadosProcurador?.cpf ? "success" : ""
                }
                required
              />
            )}
          </InputMask>
        </Grid>
        <Grid item xs={12} sm={2}>
          <InputMask
            mask="(99) 9999 9999"
            maskChar={null}
            value={dataForm?.dadosProcurador?.telefone || ""}
            onChange={handleChange}
          >
            {() => (
              <TextField
                size="small"
                name="telefone"
                label="Telefone"
                fullWidth
              />
            )}
          </InputMask>
        </Grid>

        <Grid item xs={12} sm={2}>
          <InputMask
            mask="(99) 9 9999 9999"
            maskChar={null}
            value={dataForm?.dadosProcurador?.whatsapp || ""}
            onChange={handleChange}
          >
            {() => (
              <TextField
                size="small"
                label="WhatsApp"
                name="whatsapp"
                fullWidth
                error={handleError("dadosProcurador", "whatsapp")}
                helperText={handleHelperText("dadosProcurador", "whatsapp")}
                required
              />
            )}
          </InputMask>
        </Grid>
      </Grid>
      <div className={styles.container_button}>
        <Button className={styles.button_back} onClick={handleBack}>
          Voltar
        </Button>
        <Button className={styles.button_next} type="submit">
          Avançar
        </Button>
      </div>
    </form>
  );
};

export default DadosProcurador;
